<template>
  <div class="loader__main">
    <div class="loader"></div>
  </div>
</template>

<style scoped>
.loader__main {
  display: flex;

  justify-content: center;
  align-items: center;
  /* border :1px solid black; */
  width: 100%;
  height: 100%;
}
.loader {
  border: 0.2px solid #f3f3f3;
  border-radius: 60%;
  border-top: 3px solid #ed2027;
  width: 16px;
  height: 18px;
  -webkit-animation: spin 5s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<script>
export default {
  name: "Loading",
};
</script>
